// download.stats.dto.ts
import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const downloadStatsSchema = z.object({
  total: z.number(),
  byResume: z.array(
    z.object({
      resumeId: z.string(),
      title: z.string(),
      count: z.number(),
    }),
  ),
});

export class DownloadStatsDto extends createZodDto(downloadStatsSchema) {}
